import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private apiUrl = environment.accountsUrl;
  private http = inject(HttpClient);
  
  verifyEmail(token: string) {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const body = {};
    const urlpath = this.apiUrl + '/account/verifyemail?token=' + token;
    return this.http.post<Response>(urlpath, body, { headers });
  }

  requestCode(reqcodeobj: any): any {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const urlpath = this.apiUrl + '/account/requestCode';
    return this.http.post<Response>(urlpath, reqcodeobj, { headers });
  }

  verifyUser(verifyobj: any): any {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const urlpath = this.apiUrl + '/account/verifyUser';
    return this.http.post<Response>(urlpath, verifyobj, { headers });
  }

  
  loginUser(authobj: any): any {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const urlpath = this.apiUrl + '/account/loginUser';
    return this.http.post<Response>(urlpath, authobj, { headers });
  }

  loginUserWithOtp(authobj: any): any {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const urlpath = this.apiUrl + '/account/loginUserWithOTP';
    return this.http.post<Response>(urlpath, authobj, { headers });
  }

  getUserProfile(): any {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const urlpath = this.apiUrl + '/account/getUserProfile';
    return this.http.get(urlpath, { headers });
  }

  updateUserProfile(userobj: any): any {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const urlpath = this.apiUrl + '/account/updateUserProfile';
    return this.http.put<Response>(urlpath, userobj, { headers });
  }

  updateUserProfilePassword(userobj: any): any {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const urlpath = this.apiUrl + '/account/updateUserProfilePassword';
    return this.http.put<Response>(urlpath, userobj, { headers });
  }

  
  fetchAdditionalUsers(accountid: string): any {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const urlpath = this.apiUrl + '/account/' + accountid + '/users';
    return this.http.get<any>(urlpath, { headers });
  }

  addAdditionalUser(accountid: string, adduser: any): any {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const urlpath = this.apiUrl + '/account/' + accountid + '/inviteUser';
    return this.http.post<Response>(urlpath, adduser, { headers });
  }

  updateUserDetails(userid: string, userobj: any): any {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const urlpath = this.apiUrl + '/accounts/updateUserDetails/?userid=' + userid;
    return this.http.put<Response>(urlpath, userobj, { headers });
  }

  fetchAccountInfo(accountid: string): any {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const urlpath = `${this.apiUrl}/account/${accountid}/info`;
    return this.http.get<any>(urlpath, { headers });
  }

  updateAccountInfo(accountid: string, businessInfo: any): any {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const urlpath = `${this.apiUrl}/account/${accountid}/updateInfo`;
    return this.http.post<any>(urlpath, businessInfo, { headers });
  }

  fetchAccountSubscription(accountid: string): any {
    const headers = new HttpHeaders().set('content-type', 'application/json');
    const urlpath = this.apiUrl + '/accounts/businessSubscriptionInfo/' + accountid;
    return this.http.get<any>(urlpath, { headers });
  }

  

}
